"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageHelperTypes = exports.Cookies = exports.Regex = exports.ModalTypes = exports.Images = exports.PublicUrls = exports.Routes = void 0;
const helpers_1 = require("@/helpers");
const strings_1 = __importDefault(require("./strings"));
// Routes
exports.Routes = {
    // Generic
    Login: '/login',
    Home: '/',
    SignUp: '/signup',
    VerifyEmail: '/verify-email',
    VerifyEmailConfirm: '/verify-email-confirm',
    ResetPassword: '/reset-password',
    ResetPasswordChange: '/reset-password-change',
    ResetPasswordInstructions: '/reset-password-instructions',
    Program: '/program',
    Support: '/support',
    Profile: '/profile',
    PasswordCreation: '/password-creation',
    ManageAccounts: '/manage-accounts',
    ManageAccountsCreate: '/manage-accounts/create',
    ManageAccountsDetail: '/manage-accounts/:accountId',
    ManagePrograms: '/manage-programs',
    ManageProgramsCreate: '/manage-programs/create',
    ManageProgramsDetail: '/manage-programs/:programId',
    PatientProgress: '/patient-progress',
    PatientProgressDetail: '/patient-progress/:accountId',
    PatientProcessQuestion: '/patient-progress/:patientId/process-questions/:contentId',
    PaywallSessions: '/paywall/sessions',
    PaywallPayment: '/paywall/payment',
    TherapyNoteCreate: `/patient-progresss/:accountId/session/:sessionId/therapy-note`,
    TherapyNoteEdit: `/patient-progresss/:accountId/session/:sessionId/therapy-note/:therapyNoteId`
};
exports.PublicUrls = {
    privacyPolicy: "https://summithillwellness.com/policy/",
    appStore: "https://apps.apple.com/cd/app/addiction-recovery-online/id1561816352",
    playStore: "https://play.google.com/store/apps/details?id=com.summithill&hl=en&gl=US"
};
const getImagePath = (image) => STORYBOOK
    ? require(`../../../../backend/summithill/static/images/${image}`).default // eslint-disable-line import/no-dynamic-require
    : helpers_1.staticPath(`/images/${image}`);
exports.Images = {
    searchIcon: getImagePath('search.png'),
    searchPressed: getImagePath('search-pressed.png'),
    success: getImagePath('check@2x.png'),
    triangle: getImagePath('triangle@2x.png'),
    error: getImagePath('red-close@2x.png'),
    logo: getImagePath('logo@3x.png'),
    loginBackground: getImagePath('login-background.png'),
    bookmark: getImagePath('bookmark@2x.png'),
    bookmarkPressed: getImagePath('bookmark-pressed@2x.png'),
    bannerBellIcon: getImagePath('bell@3x.png'),
    bannerInfoIcon: getImagePath('info.png'),
    bannerWarningIcon: getImagePath('warning@3x.png'),
    chevronRight: getImagePath('chevron-right@3x.png'),
    heart: getImagePath('heart@3x.png'),
    angleDown: getImagePath('angle-down@3x.png'),
    angleDownDisabled: getImagePath('angle-down-disabled@3x.png'),
    mail: getImagePath('mail@3x.png'),
    mailActive: getImagePath('mail-active@3x.png'),
    mailError: getImagePath('mail-error@3x.png'),
    eye: getImagePath('eye@3x.png'),
    eyeActive: getImagePath('eye-active@3x.png'),
    eyeError: getImagePath('eye-error@3x.png'),
    eyeClose: getImagePath('eye-close@3x.png'),
    eyeCloseActive: getImagePath('eye-close-active@3x.png'),
    eyeCloseError: getImagePath('eye-close-error@3x.png'),
    userCheck: getImagePath('user-check@3x.png'),
    userCheckActive: getImagePath('user-check-active@3x.png'),
    userCheckError: getImagePath('user-check-error@3x.png'),
    clipboard: getImagePath('clipboard.png'),
    clipboardActive: getImagePath('clipboard-active.png'),
    user: getImagePath('user.png'),
    userActive: getImagePath('user-active.png'),
    helpCircle: getImagePath('help-circle.png'),
    helpCircleActive: getImagePath('help-circle-active.png'),
    navLogo: getImagePath('nav-logo.png'),
    userPlaceholder: getImagePath('user-placeholder.png'),
    accordionAngleUp: getImagePath('accordion-angle-up@3x.png'),
    accordionAngleDown: getImagePath('accordion-angle-down@3x.png'),
    mailSent: getImagePath('mail-sent@3x.png'),
    playFilled: getImagePath('play-filled@3x.png'),
    pauseFilled: getImagePath('pause-filled@3x.png'),
    maximize: getImagePath('maximize@3x.png'),
    lock: getImagePath('lock@3x.png'),
    playIcon: getImagePath('play-icon@3x.png'),
    playIconActive: getImagePath('play-icon-active@3x.png'),
    check: getImagePath('check@3x.png'),
    yellowBookIcon: getImagePath('book.png'),
    bookIcon: getImagePath('book-icon@3x.png'),
    bookIconActive: getImagePath('book-icon-active@3x.png'),
    calendarIcon: getImagePath('calendar-icon@3x.png'),
    calendarIconActive: getImagePath('calendar-icon-active@3x.png'),
    undrawBookLover: getImagePath('undraw_book_lover.png'),
    undrawBookLoverMobile: getImagePath('undraw_book_lover_mobile.png'),
    todoListCheckList: getImagePath('todo-list-check.png'),
    undrawCheckList: getImagePath('undraw-checklist.png'),
    undrawCheckListMobile: getImagePath('undraw-checklist-mobile.png'),
    undrawBooking: getImagePath('undraw-booking.png'),
    undrawBookingMobile: getImagePath('undraw-booking-mobile.png'),
    orangeCalendar: getImagePath('orange-calendar@3x.png'),
    greyClose: getImagePath('grey-close@3x.png'),
    undrawCoWorkers: getImagePath('undraw-co-workers.png'),
    greenMail: getImagePath('green-mail@3x.png'),
    undrawIdeas: getImagePath('undraw-ideas.png'),
    blackClose: getImagePath('black-close@3x.png'),
    processComplete: getImagePath('ok.png'),
    blueClose: getImagePath('blue-close.svg'),
    search: getImagePath('search@3x.png'),
    searchActive: getImagePath('search-active@3x.png'),
    filter: getImagePath('filter@3x.png'),
    filterActive: getImagePath('filter-active@3x.png'),
    clear: getImagePath('clear@3x.png'),
    directions: getImagePath('directions@3x.png'),
    directionsDown: getImagePath('directions-down@3x.png'),
    directionsUp: getImagePath('directions-up@3x.png'),
    send: getImagePath('send@3x.png'),
    sendActive: getImagePath('send-active@3x.png'),
    plus: getImagePath('plus@3x.png'),
    clearGreen: getImagePath('clear-green@3x.png'),
    calendar: getImagePath('calendar@3x.png'),
    calendarActive: getImagePath('calendar-active@3x.png'),
    arrowsUpDown: getImagePath('arrows-up-down.png'),
    undrawChoose: getImagePath('undraw-choose.png'),
    angleDownGreen: getImagePath('angle-down-green@3x.png'),
    page404: getImagePath('404.png'),
    arrowLeftGreen: getImagePath('arrow-left-green@3x.png'),
    congrats: getImagePath('congrats@3x.png'),
    undrawCancel: getImagePath('undraw-cancel@3x.png'),
    playStore: getImagePath('play-store.png'),
    appStore: getImagePath('app-store.png'),
    undrawCompleting: getImagePath('undraw-completing.png'),
    trashRed: getImagePath('trash-red@3x.png'),
    sendGreen: getImagePath('send-green@3x.png'),
    drag: getImagePath('drag.png'),
    trash: getImagePath('trash.png'),
};
exports.ModalTypes = {};
exports.Regex = {
    oneLower: /(?=.*[a-z])/,
    oneUpper: /(?=.*[A-Z])/,
    oneNumber: /.*[0-9].*/,
    oneSpecialChar: /(?=.*[~`!@#$%^&*()+=_\-{}[\]|:;"'?/<>,.])/,
};
exports.Cookies = {
    auth: 'auth',
};
exports.StorageHelperTypes = {
    cookie: 'cookie',
    local: 'local',
};
exports.default = strings_1.default;
